
import { TranslationSet } from '../types';

export const password: TranslationSet = {
  'forgotPassword.title': {
    en: 'Forgot Password',
    ja: 'パスワードをお忘れですか',
    es: '¿Olvidaste tu contraseña?',
    zh: '忘记密码',
    fa: 'فراموشی رمز عبور'
  },
  'forgotPassword.subtitle': {
    en: 'Enter your email address to reset your password.',
    ja: 'パスワードをリセットするにはメールアドレスを入力してください。',
    es: 'Introduce tu correo electrónico para restablecer tu contraseña.',
    zh: '输入您的电子邮件地址以重置您的密码。',
    fa: 'برای بازنشانی رمز عبور خود، آدرس ایمیل خود را وارد کنید.'
  },
  'forgotPassword.form.email': {
    en: 'Email',
    ja: 'メールアドレス',
    es: 'Correo electrónico',
    zh: '电子邮件',
    fa: 'ایمیل'
  },
  'forgotPassword.form.resetPassword': {
    en: 'Reset Password',
    ja: 'パスワードをリセット',
    es: 'Restablecer contraseña',
    zh: '重置密码',
    fa: 'بازنشانی رمز عبور'
  },
  'forgotPassword.backToLogin': {
    en: 'Back to Login',
    ja: 'ログインに戻る',
    es: 'Volver a Iniciar sesión',
    zh: '返回登录',
    fa: 'بازگشت به صفحه ورود'
  },
  'forgotPassword.successMessage': {
    en: 'Password reset link sent to your email address.',
    ja: 'パスワードリセットリンクがメールアドレスに送信されました。',
    es: 'Se ha enviado un enlace de restablecimiento de contraseña a tu correo electrónico.',
    zh: '密码重置链接已发送到您的电子邮件地址。',
    fa: 'لینک بازنشانی رمز عبور به آدرس ایمیل شما ارسال شد.'
  },
  'forgotPassword.errorMessage': {
    en: 'Failed to send reset password link. Please try again.',
    ja: 'パスワードリセットリンクの送信に失敗しました。もう一度お試しください。',
    es: 'Error al enviar el enlace de restablecimiento de contraseña. Por favor, inténtalo de nuevo.',
    zh: '发送密码重置链接失败。请重试。',
    fa: 'ارسال لینک بازنشانی رمز عبور با خطا مواجه شد. لطفا دوباره تلاش کنید.'
  },
  'resetPassword.title': {
    en: 'Reset Password',
    ja: 'パスワードをリセット',
    es: 'Restablecer contraseña',
    zh: '重置密码',
    fa: 'بازنشانی رمز عبور'
  },
  'resetPassword.subtitle': {
    en: 'Enter your new password.',
    ja: '新しいパスワードを入力してください。',
    es: 'Introduce tu nueva contraseña.',
    zh: '输入您的新密码。',
    fa: 'رمز عبور جدید خود را وارد کنید.'
  },
  'resetPassword.form.password': {
    en: 'Password',
    ja: 'パスワード',
    es: 'Contraseña',
    zh: '密码',
    fa: 'رمز عبور'
  },
  'resetPassword.form.confirmPassword': {
    en: 'Confirm Password',
    ja: 'パスワードを確認',
    es: 'Confirmar contraseña',
    zh: '确认密码',
    fa: 'تایید رمز عبور'
  },
  'resetPassword.form.resetPassword': {
    en: 'Reset Password',
    ja: 'パスワードをリセット',
    es: 'Restablecer contraseña',
    zh: '重置密码',
    fa: 'بازنشانی رمز عبور'
  },
  'resetPassword.passwordMismatch': {
    en: 'Passwords do not match',
    ja: 'パスワードが一致しません',
    es: 'Las contraseñas no coinciden',
    zh: '密码不匹配',
    fa: 'رمزهای عبور مطابقت ندارند'
  },
  'resetPassword.successMessage': {
    en: 'Password reset successfully!',
    ja: 'パスワードが正常にリセットされました！',
    es: 'Contraseña restablecida con éxito!',
    zh: '密码重置成功！',
    fa: 'رمز عبور با موفقیت بازنشانی شد!'
  },
  'resetPassword.errorMessage': {
    en: 'Failed to reset password. Please try again.',
    ja: 'パスワードのリセットに失敗しました。もう一度お試しください。',
    es: 'Error al restablecer la contraseña. Por favor, inténtalo de nuevo.',
    zh: '重置密码失败。请重试。',
    fa: 'بازنشانی رمز عبور با خطا مواجه شد. لطفا دوباره تلاش کنید.'
  }
};
